//TODO: use library
export const countryCityOptions = [
    {
        value: "Hong Kong",
        label: "Hong Kong ",
    },
    {
        value: "Singapore",
        label: "Singapore",
    },
];
